/**
 * Offer Section — pt_403
 * File: assets/offer-section.js
 *
 * Behaviour:
 *  - Subscribe radio selected  → remove  pt_403_oneTime_active from container
 *  - One-Time  radio selected  → add     pt_403_oneTime_active on container
 */

(function () {
  'use strict';

  var ACTIVE_CLASS  = 'pt_403_oneTime_active';
  var CONTAINER_ID  = 'pt_403_product_container';

  function init() {
    var container  = document.getElementById(CONTAINER_ID);
    if (!container) return;

    var radios = container.querySelectorAll('input[name="pt_403_subs"]');
    if (!radios.length) return;

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        handleChange(container, this.value);
      });
    });

    // Run once on load to honour the pre-checked state
    var checked = container.querySelector('input[name="pt_403_subs"]:checked');
    if (checked) handleChange(container, checked.value);
  }

  /**
   * Toggle the active class based on which radio value is selected.
   * @param {HTMLElement} container
   * @param {string} value  – "subscribe" | "onetime"
   */
  function handleChange(container, value) {
    if (value === 'onetime') {
      container.classList.add(ACTIVE_CLASS);
    } else {
      container.classList.remove(ACTIVE_CLASS);
    }
  }

  // Initialise after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
